
const Basvuru = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Application</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>Companies and entrepreneurs wishing to operate within POLSAN Technopark in order to benefit from the provisions of Law No. 4691 on Technology Development Zones and its implementing regulation, as well as other relevant laws and regulations, can complete all application and subsequent processes through the portal.</p>
          <p>The application process commences with the applicant company completing the application form via the system and uploading the required supporting documents. Following submission of the application form, an authorized representative of the Managing Company reviews the application together with its annexes. Any identified deficiencies or required revisions are communicated to the applicant, and the company is requested to make the necessary corrections. In line with the feedback provided, the applicant revises the application form and resubmits it to the Managing Company for further review. This review, evaluation and revision cycle continues until the application form is finalized.</p>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="d-grid col-md-2 col-sm-6 mx-auto">
          <a href="https://basvuru.polsanteknokent.com.tr" className="btn btn-primary btn-lg btn-basvuru" role="button" target="_blank">APPLICATION</a>
        </div>
      </div>
    </>
  );
};

export default Basvuru;
